import { useState } from 'react'

function ChangeReasonModal({ changeCount, sectionCount, onConfirm, onCancel, saving }) {
  const [reason, setReason] = useState('')

  const canSubmit = reason.trim().length >= 10 && !saving

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onCancel} />
      <div className="relative bg-white dark:bg-gray-800 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 w-full max-w-md mx-4 p-6">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-1">Save Assessment Changes</h2>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
          You changed <span className="font-medium text-gray-900 dark:text-white">{changeCount} question{changeCount !== 1 ? 's' : ''}</span> across <span className="font-medium text-gray-900 dark:text-white">{sectionCount} section{sectionCount !== 1 ? 's' : ''}</span>. Scores will be recalculated.
        </p>

        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Reason for changes <span className="text-red-500">*</span>
        </label>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Describe why these changes were made (min. 10 characters)..."
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent resize-none"
          autoFocus
        />
        {reason.length > 0 && reason.trim().length < 10 && (
          <p className="text-xs text-red-500 mt-1">{10 - reason.trim().length} more characters needed</p>
        )}

        <div className="flex justify-end gap-3 mt-5">
          <button
            onClick={onCancel}
            disabled={saving}
            className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(reason.trim())}
            disabled={!canSubmit}
            className="px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-lg hover:bg-primary-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ChangeReasonModal
